class Bom {
	constructor({
		id = '',
		productId = '',
		manufacturer = '',
		name = '',
		jlcpcbNumber = '',
		link = '',
		unitUsd = 0,
		quantity = 0,
		useYn = 0,
		updatedBy = '',
		updatedAt = '',
		createdBy = '',
		createdAt = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.productId = productId === null ? '' : productId
		this.manufacturer = manufacturer === null ? '' : manufacturer
		this.name = name === null ? '' : name
		this.jlcpcbNumber = jlcpcbNumber === null ? '' : jlcpcbNumber
		this.link = link === null ? '' : link
		this.unitUsd = unitUsd === null ? 0 : Number(unitUsd)
		this.quantity = quantity === null ? 0 : quantity
		this.useYn = useYn === null ? 0 : useYn
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.createdBy = createdBy === null ? '' : createdBy
		this.createdAt = createdAt === null ? '' : createdAt
	}
	id: string
	productId: string
	manufacturer: string
	name: string
	jlcpcbNumber: string
	link: string
	unitUsd: number
	quantity: number
	useYn: number
	updatedBy: string
	updatedAt: string
	createdBy: string
	createdAt: string
}

export { Bom }
